import React, { Fragment, useEffect, useState } from "react";
import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const CompanyList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
        { title: "TIN", fieldName: "tin" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.Company} />
        </>
    );
};


export default CompanyList;